export default __webpack_public_path__ + "static/media/HomeCelsius.ff3c26e5.svg";